import {useIntl} from "react-intl";
import {Button, Col, Form, Icon, Row, Upload, Table, Tag} from "antd";
import React, {useEffect, useState} from "react";
import CustomRxPageHeader from "../../rxcomponents/CustomRxPageHeader";
import {
    downloadBankTransferTemplateFile,
    downloadBatchFile,
    getNewBatchUploads,
    uploadBatchTransferFile
} from "../../api/api";
import {displayError, displayGenericError, displaySuccessMessageWithSeconds} from "../../common/notifications";
import withUseIntl from "../../components/withUseIntl";
import moment from "moment";
import {DEFAULT_PAGE_SIZE_10} from "../../common/Const";
import {Pagination} from "antd";
import '../../index.scss';

export function BatchUploadPage(props) {

    const intl = useIntl();

    const [batchUploads, setBatchUploads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState([0]);
    const [totalItem, setTotalItem] = useState([0]);

    useEffect(() => {
        getData(page);
    }, [])

    const getData = (page) => {
        setLoading(true);
        getNewBatchUploads(page,DEFAULT_PAGE_SIZE_10).then(response => {
            setBatchUploads(response.content);
            setLoading(false);
            setTotalItem(response.totalElements)
        })
            .catch(error => {
                displayGenericError(error);
                setLoading(false);
            });
    }

    const downloadTemplateFile = () => {
        downloadBankTransferTemplateFile();
    }

    const downloadTemplateFileXLSX = () => {
        downloadBankTransferTemplateFile("xlsx");
    }

    const processUpload = ({file}) => {
        uploadBatchTransferFile(file)
            .then(response => {
                getData(page);
                let msg = intl.formatMessage({id:"app.common.successfully"})
                displaySuccessMessageWithSeconds(msg, 2)
            }).catch(e=>{
                // alert(JSON.stringify(e));
            displayError(e.result);
        })
    }

    const onDownloadLinkClicked = id => {
        downloadBatchFile(id).then(response => {
            // var win = window.open(response.link, "_blank");
            // win.focus();
        })
            .catch(error => {
                displayGenericError(error);
            });
    }

    const  columns = [

        {
            title: intl.formatMessage({id: "app.page.batch.upload.upload.date"}),
            dataIndex: "dateCreated",
            key: "dateCreated",
            render: dateCreated =>
                `${moment(dateCreated).format("YYYY-MM-DD HH:mm:ss")}`
        },

        // {title: "Source", dataIndex: "source", key: "source"},
        {title: intl.formatMessage({id: "app.page.batch.upload.upload.by"}), dataIndex: "uploadBy", key: "uploadBy"},
        {title: intl.formatMessage({id: "app.common.status"}), dataIndex: "status", key: "status",
        render: (text,record) =>{
            if(text == 'CANCELLED') {
                return <Tag color={'red'}>{text.toUpperCase()}</Tag>;
            } else {
                return <Tag >{text.toUpperCase()}</Tag>;
            }
        }
        },
        {title: intl.formatMessage({id: "app.common.reason"}), dataIndex: "note", key: "note"},
        {
            title: intl.formatMessage({id: "app.page.batch.upload.batch.file"}),
            dataIndex: "uploadFilePath",
            key: "uploadFilePath",
            render: (text, record) => (
                <a onClick={() => onDownloadLinkClicked(text)}>{intl.formatMessage({id: "app.common.download"})}</a>
            )
        },
        // {
        //     title: "Action",
        //     dataIndex: "action",
        //     key: "action",
        //     render: (text, record) => {
        //         if (record.status === 'NEW') {
        //             return <a onClick={() => this.onProcessLinkClicked(record.uploadFilePath, record.id)}>Process</a>
        //         }
        //     }
        // },
    ];

    let currentPage = +page + +1;
    return (
        <div>
            <CustomRxPageHeader customer={props.customer}
                title={intl.formatMessage({id: "app.sidebar.batch.upload"})}
            />
            <div className="bp-page-content bp-page-large">
                <div className={"content-section"}>
                    {/*{currentStep === "upload" && (*/}
                    <div>
                        <Form name="uploadForm">
                            <Row gutter={{xs: 4, sm: 8}}>
                                <Col md={{span: 4}} xs={{span: 18}}>
                                    <Upload
                                        defaultFileList={[]}
                                        customRequest={processUpload}
                                        showUploadList={false}
                                    >
                                        <Button
                                            className="upload-button"
                                        >
                                            <Icon
                                                type="upload"/> {intl.formatMessage({id: "app.page.batch.upload.batch-upload-transfer-order"})}
                                        </Button>
                                    </Upload>
                                </Col>
                                <Col md={{span: 4}} xs={{span: 18}}>
                                    <a style={{marginLeft: '15px'}} onClick={downloadTemplateFile}>
                                        {intl.formatMessage({id: "app.page.batch.upload.batch-upload-file-template-csv"})}
                                    </a> <br/>
                                    <a style={{marginLeft: '15px'}} onClick={downloadTemplateFileXLSX}>
                                        {intl.formatMessage({id: "app.page.batch.upload.batch-upload-file-template-xlsx"})}
                                    </a>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    {/*)}*/}
                    <br/>
                    <div>
                        <Table
                            loading={loading}
                            pagination={false}
                            columns={columns}
                            dataSource={batchUploads}
                        />
                    </div> <br/>
                    <div style={{float: "right"}}>
                        <Pagination current={currentPage} pageSize={DEFAULT_PAGE_SIZE_10} total={totalItem} onChange={(value) => {
                            getData(value-1)
                            setPage(value-1)
                        }}/>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default withUseIntl(BatchUploadPage)